import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { ForwardPage } from '../ForwardPage/ForwardPage';
import { PreviousPage } from '../PreviousPage/PreviousPage';
import { SubmitButton } from '../SubmitButton/SubmitButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';

export const Paginator = observer(props => {
  const { current, contentLayout, settings, environment, orders, setActivePage } = props;
  const { next, back, showIcons } = settings;

  const checkMinGroupReg = useCallback(() => {
    const grpModule = contentLayout?.contentLayoutModules
      ?.filter(clm => clm.pages == current.activePage)
      .find(clm => clm.contentModule.type === 'GROUP_REGISTRATION');

    const minCount = grpModule?.contentModule?.settings?.minCount;
    return minCount > 0 && minCount > orders.length;
  }, [orders, current?.activePage, contentLayout?.contentLayoutModules]);

  const grpRegDisabled = useMemo(() => checkMinGroupReg(), [orders, checkMinGroupReg, current?.activePage]);

  const groupRegValidationMessage = useMemo(() => {
    const grpModule = contentLayout?.contentLayoutModules
      ?.filter(clm => clm.pages == current.activePage)
      .find(clm => clm.contentModule.type === 'GROUP_REGISTRATION');

    const minCount = grpModule?.contentModule?.settings?.minCount;
    const maxCount = grpModule?.contentModule?.settings?.maxCount;

    if (minCount > 0 && minCount > orders.length) {
      return {
        label: `MinimumOrdersRequired`,
        value: minCount,
      };
    }

    if (maxCount > 0 && maxCount < orders.length) {
      return {
        label: `MaximumOrdersAllowed`,
        value: maxCount,
      };
    }

    return null;
  }, [orders, current?.activePage, contentLayout?.contentLayoutModules]);

  if (contentLayout.pages == 1) {
    return <SubmitButton {...props} grpRegDisabled={grpRegDisabled} groupRegValidationMessage={groupRegValidationMessage} />;
  }

  return (
    <div className={twMerge('flex w-full  ', current.activePage > 1 ? 'justify-between' : 'justify-end')}>
      {current.activePage > 1 && (
        <PreviousPage current={current} setActivePage={setActivePage} text={showIcons ? <ArrowBackIosIcon className="arrow-icon" /> : back[environment.lang]} />
      )}
      {current.activePage === contentLayout.pages ? (
        <SubmitButton {...props} grpRegDisabled={grpRegDisabled} groupRegValidationMessage={groupRegValidationMessage} />
      ) : (
        <ForwardPage
          {...props}
          grpRegDisabled={grpRegDisabled}
          setActivePage={setActivePage}
          text={showIcons ? <ArrowForwardIosIcon className="arrow-icon" /> : next[environment.lang]}
        />
      )}
    </div>
  );
});
